import { apiSlice } from "./apiSlice";
import { SUBJECTS_URL } from "../constants";

export const subjectApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Create subject
    createSubject: builder.mutation({
      query: (data) => ({
        url: SUBJECTS_URL,

        method: "POST",

        body: data,
      }),

      invalidatesTags: ["Subject"],
    }),

    // Get all subjects
    getSubjects: builder.query({
      query: () => ({
        url: SUBJECTS_URL,
      }),

      providesTags: ["Subject"],

      keepUnusedDataFor: 5,
    }),

    // Get subject details
    getSubjectDetails: builder.query({
      query: (id) => ({
        url: `${SUBJECTS_URL}/${id}`,
      }),

      providesTags: ["Subject"],

      keepUnusedDataFor: 5,
    }),

    // Update subject
    updateSubject: builder.mutation({
      query: (data) => ({
        url: `${SUBJECTS_URL}/${data.subjectId}`,

        method: "PUT",

        body: data,
      }),

      invalidatesTags: ["Subject"],
    }),

    // Delete subject
    deleteSubject: builder.mutation({
      query: (id) => ({
        url: `${SUBJECTS_URL}/${id}`,

        method: "DELETE",
      }),

      invalidatesTags: ["Subject"],
    }),
  }),
});

export const {
  useCreateSubjectMutation,

  useGetSubjectsQuery,

  useGetSubjectDetailsQuery,

  useUpdateSubjectMutation,

  useDeleteSubjectMutation,
} = subjectApiSlice;
